import Alpine from 'alpinejs';

import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';

import effectsStore from './stores/effects';
import cmsStore from './stores/cms';
import photoswipeStore from './stores/photoswipe';

window.Alpine = Alpine;

Alpine.plugin(collapse);
Alpine.plugin(intersect);

Alpine.store('effects', effectsStore);
Alpine.store('cms', cmsStore);
Alpine.store('photoswipe', photoswipeStore);

Alpine.start();
